var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import Calendar from './utils/Calendar';
import CalendarLegend from './utils/CalendarLegend';
import { SelectDueDateContainer } from './subcomponents';
import triggerChangePaymentDueDateAnalytics from '../../helpers/trigger-change-payment-due-date-analytics';
import { PAGE_NAME } from '../../const/analytics';
var SelectDueDate = function (_a) {
    var currentDueDay = _a.currentDueDay, eligibleDueDays = _a.eligibleDueDays, handleSelectDay = _a.handleSelectDay, selectedDay = _a.selectedDay;
    useEffect(function () {
        triggerChangePaymentDueDateAnalytics({
            pageName: PAGE_NAME.START
        });
    }, []);
    return (_jsxs(SelectDueDateContainer, __assign({ "data-testid": "select-due-date" }, { children: [_jsx(Calendar, { currentDueDay: currentDueDay, eligibleDueDays: eligibleDueDays, selectedDay: selectedDay, onSelectDay: handleSelectDay }), _jsx(CalendarLegend, {})] })));
};
export default SelectDueDate;
